module.exports = __webpack_public_path__ + "static/media/success.36292936.png";